import { HiverAxios } from 'h-commons';
import {
    GET_MP_UPGRADE_PLANS_DONE,
    GET_MP_UPGRADE_PLANS_FAILED
} from './types';

export const getMultiProductUpgradePlans = () => (dispatch) => {
    HiverAxios({
        url: '/account/get-upgrade-plans',
        type: 'GET',
        callback: resp => {
            if (resp) {
                dispatch({
                    type: GET_MP_UPGRADE_PLANS_DONE,
                    payload: resp.data
                })
            } else {
                dispatch({ type: GET_MP_UPGRADE_PLANS_FAILED });
            }
        },
        onfail: () => dispatch({ type: GET_MP_UPGRADE_PLANS_FAILED })
    })
}